import request from '@/axios'
import type { TokenType } from './types'

/** 登录模块 */
export const LoginApi = {
  /** 发送验证码 */
  sendSmsCode: async (data: any): Promise<boolean> => {
    return await request.post({ url: `/member/auth/send-sms-code`, data })
  },
  /** 手机验证码登录 */
  smsLogin: async (data: any): Promise<TokenType> => {
    return await request.post({ url: `/member/auth/sms-login`, data })
  },

  /** 密码登录 */
  authLogin: async (data: any): Promise<TokenType> => {
    return await request.post({ url: `/member/auth/login`, data })
  },

  /** 公众号扫码登录 */
  authMpQrcodeLogin: async (params: any): Promise<string> => {
    return await request.get({ url: `/member/auth/auth-mp-qrcode`, params })
  },

  /** 公众号 轮询状态 */
  authMpQrcodeCheck: async (params: any): Promise<TokenType> => {
    return await request.get({ url: `/member/auth/auth-mp-qrcode-check`, params })
  },

  /** 登出 */
  authLogout: async (): Promise<boolean> => {
    return await request.post({ url: `/member/auth/logout` })
  },
}

// 获取验证图片以及 token
export const getCode = (data: any) => {
  return request.postOriginal({ url: '/system/captcha/get', data })
}

// 滑动或者点选验证
export const reqCheck = (data: any) => {
  return request.postOriginal({ url: '/system/captcha/check', data })
}
